import React, {useState} from 'react';
import {FormCheck} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useDispatch, useSelector} from 'react-redux';
import {hideWithdrawalModal, showWithdrawalModal, snapshotWithdrawalPoints} from '../../../actions/shippingPage';

export const ShippingWithdrawal = ({shippingMethod}) => {
  const {withdrawalPointsSelected} = useSelector(
    state => ({
      withdrawalPointsSelected: state.shippingReducer.payload.withdrawalPointsSelected[shippingMethod.id] || null,
    }),
  );

  return (
    <>
      <ShippingWithdrawalModal pointList={shippingMethod.pointList}
                               snapshotPoint={withdrawalPointsSelected}
                               shippingMethodId={shippingMethod.id}
                               type={shippingMethod.type}/>
    </>
  );
};

const ShippingWithdrawalModal = ({pointList, snapshotPoint, shippingMethodId, type}) => {
  const dispatch = useDispatch();
  const deliveryPoints = [];

  const {show} = useSelector(
    state => ({
      show: state.shippingReducer.showWithdrawalModal,
    })
  );

  const handleShow = () => dispatch(showWithdrawalModal());
  const handleClose = () => dispatch(hideWithdrawalModal());

  for (const [pointId, point] of Object.entries(pointList)) {
    deliveryPoints.push(<ShippingWithdrawalPoint key={pointId}
                                                 checked={snapshotPoint !== null && pointId === snapshotPoint.id}
                                                 point={point}
                                                 shippingMethodId={shippingMethodId}
                                                 hideModal={handleClose}
    />);
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered aria-labelledby="contained-modal-title-vcenter"
             dialogClassName="shipping-method-modal shipping-method-modal-withdrawal bootstrap" size="lg"
      >
        <Modal.Header className="head" closeButton>
          <Modal.Title>{window.trans(`front.order.checkout.shipping_step.shipping_method.${type}.title`)}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="content wysiwyg">
          <div className="text-center">
            <ul className="list form">
              {deliveryPoints}
            </ul>
          </div>
        </Modal.Body>
      </Modal>

      <ShippingWithdrawalButton type={type} shippingMethodId={shippingMethodId} showModal={handleShow}/>
    </>
  );
};


const ShippingWithdrawalButton = ({type, shippingMethodId, showModal}) => {
  const {withdrawalPointsSelected, shippingAddressesLoading} = useSelector(
    state => ({
      withdrawalPointsSelected: state.shippingReducer.payload.withdrawalPointsSelected[shippingMethodId] || null,
      shippingAddressesLoading: state.shippingReducer.shippingAddressesLoading,
    })
  );

  let button = <></>;

  if (withdrawalPointsSelected === null) {
    button = <Button className="btn btn-warning card__footer-button" disabled={shippingAddressesLoading}
                     onClick={showModal}>
      <i
        className="fa fa-info-circle fa-2"/>{window.trans(`front.order.checkout.shipping_step.shipping_method.${type}.select`)}
    </Button>;
  } else {
    button = (
      <div>
        <Button disabled={true} type="button" className="btn btn-info mb-3 card__footer-button">
          <i
            className="fa fa-check-circle fa-2"/>{window.trans(`front.order.checkout.shipping_step.shipping_method.${type}.selected`)}<br/>
        </Button>
        <p>
          <a onClick={showModal} href="#">
            {window.trans(`front.order.checkout.shipping_step.shipping_method.${type}.select.new`)}</a>
        </p>
      </div>
    );
  }

  return (
    <div className="bootstrap">
      {button}
    </div>
  );
};

const ShippingWithdrawalPoint = ({point, checked, shippingMethodId, hideModal}) => {
  const dispatch = useDispatch();

  const {withdrawalPointsSelected} = useSelector(
    state => ({
      withdrawalPointsSelected: state.shippingReducer.payload.withdrawalPointsSelected,
    })
  );

  return (
    <li className="card">
      <div className="shipping-method-modal__content card-flex">
        <div className="shipping-method-modal__withdrawal-select radio-pair">
          <FormCheck
            type={'radio'}
            custom
            id={`withdrawal-${point.id}`}
            name={`withdrawal_points[${shippingMethodId}]`}
            defaultChecked={checked}
            onClick={() => {
              hideModal();
              dispatch(snapshotWithdrawalPoints({
                ...withdrawalPointsSelected,
                [shippingMethodId]: {
                  id: point.id,
                  name: point.name,
                  ...point.address,
                },
              }));
            }}/>
        </div>
        <div className="shipping-method-modal__withdrawal-img">
          <i className={`icon ${point.icon}`}/>
        </div>
        <address className="shipping-method-modal__withdrawal-address">
          <strong>{point.name}</strong><br/>
          <small className="text-muted">
            {point.address.address1}<br/>
            {point.address.address2 !== undefined &&
            point.address.address2 && <br/>
            }
            {point.address.address3 !== undefined &&
            point.address.address3 && <br/>
            }
            {point.address.zipCode} {point.address.city}<br/>
            {point.distance && <span className="text-primary">Distance : {point.distance} m</span>}
          </small>
        </address>
      </div>
      <PointDailyOpening point={point}/>
    </li>
  );
};

const PointDailyOpening = ({point}) => {
  const [visible, setVisible] = useState(false);
  const onClick = () => {
    setVisible(!visible);
  }

  return (
    <div>
      {point.dailyOpening.length &&
      <p className="text-right">
        <a href="#" className="show-schedules text-info" onClick={onClick}>
          {window.trans('front.order.checkout.shipping_step.shipping_method.withdrawal.show_schedules')}
        </a>
      </p>
      }
      {visible &&
      <div className="more-detail-content">
        <div className="text-right"><a href="#" className="text-info less-detail" onClick={onClick}>X</a></div>
        <table className="shipping-method-modal__withdrawal-opening">
          <tbody>
          {point.dailyOpening.map(opening => {
            return <tr key={opening.day}>
              <td>{opening.dayLabel}</td>
              <td>{opening.hours}</td>
            </tr>
          })}
          </tbody>
        </table>
      </div>
      }
    </div>
  );
};
